import React from 'react';
import Header from './Header/header';
import Sidebar from './Sidebar/sidebar';

function Layout({ children }) {
  return (
    <div className="grid grid-rows-[auto_1fr_auto] min-h-screen">
      <Header />
      <div className="flex flex-grow mt-24">
        <Sidebar />
        <div className="flex-1 p-8 min-w-0">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;
